// Role-based route configuration
// Each role has access to specific routes based on the IgniteNext System Workflow Documentation

export const roleRoutes = {
  // STUDENT NAVIGATION - Based on Student Side Navigation section
  student: [
    { path: '/', label: 'Home', icon: 'Dashboard' },
    { path: '/complete-registration', label: 'Complete Registration', icon: 'Description' },
    { path: '/ideas-review', label: 'My Ideas', icon: 'Assessment' },
    // { path: '/engagements', label: 'My Engagements', icon: 'Assignment' },
    { path: '/calendar', label: 'Calendar', icon: 'CalendarToday' },
    { path: '/tasks', label: 'Tasks', icon: 'Checklist' },
    { path: '/mentor-events', label: 'Events', icon: 'Event' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
  ],

  // MENTOR NAVIGATION - Based on Mentor Side Navigation section
  mentor: [
    { path: '/mentor-dashboard', label: 'Home', icon: 'Dashboard' },
    { path: '/complete-registration', label: 'Complete Registration', icon: 'Description' },
    { path: '/ideas-review', label: 'Review Ideas', icon: 'Assessment' },
    { path: '/engagements', label: 'My Engagements', icon: 'Assignment' },
    { path: '/calendar', label: 'Calendar', icon: 'CalendarToday' },
    { path: '/tasks', label: 'Tasks', icon: 'Checklist' },
    { path: '/mentor-events', label: 'Events', icon: 'Event' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
  ],

  // DONOR NAVIGATION - Based on Donor Side Navigation section
  donor: [
    { path: '/donor-home', label: 'Home', icon: 'Dashboard' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
  ],

  // Ecosystem Partner & Corporate Sponsor (same nav for both)
  ecosystem_partner: [
    { path: '/', label: 'Home', icon: 'Dashboard' },
    { path: '/mentor-events', label: 'Events', icon: 'Event' },
    { path: '/complete-registration', label: 'Complete Registration', icon: 'Description' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
  ],
  corporate_sponsor: [
    { path: '/', label: 'Home', icon: 'Dashboard' },
    { path: '/mentor-events', label: 'Events', icon: 'Event' },
    { path: '/complete-registration', label: 'Complete Registration', icon: 'Description' },
  ],


  // INVESTOR NAVIGATION - Based on Investor section
  investor: [
    { path: '/', label: 'Home', icon: 'Dashboard' },
    { path: '/mentor-events', label: 'Events', icon: 'Event' },
    { path: '/complete-registration', label: 'Complete Registration', icon: 'Description' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
  ],

  // ADMIN NAVIGATION - Based on Admin Side Navigation section
  admin: [
    { path: '/admin-dashboard', label: 'Home', icon: 'Dashboard' },
    { path: '/mentors', label: 'Mentors', icon: 'Assessment' },
    { path: '/students', label: 'Students', icon: 'Assignment' },
    { path: '/ideas', label: 'Ideas', icon: 'Assessment' },
    { path: '/questions', label: 'Questions', icon: 'Help' },
    { path: '/corporate-sponsors', label: 'Corporate Sponsors', icon: 'Checklist' },
    { path: '/ecosystem-partners', label: 'Ecosystem Partners', icon: 'Checklist' },
    { path: '/donors', label: 'Donors', icon: 'Checklist' },
    { path: '/investors', label: 'Investors', icon: 'Checklist' },
    { path: '/volunteers', label: 'Volunteers', icon: 'Checklist' },
    // { path: '/email-templates', label: 'Email Templates', icon: 'Description' },
    { path: '/events', label: 'Events', icon: 'CalendarToday' },
    // { path: '/faqs', label: 'FAQs', icon: 'Help' },
    // { path: '/testimonials', label: 'Testimonials', icon: 'RateReview' },
    { path: '/content', label: 'Content', icon: 'Article' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
    { path: '/configuration', label: 'Configuration', icon: 'Settings' },
    // { path: '/admin/master-data', label: 'Master Data', icon: 'Database' },
  ],

  // PROGRAM TEAM NAVIGATION - Based on Program Team section
  program_team: [
    { path: '/', label: 'Home', icon: 'Dashboard' },
    { path: '/ideas-review', label: 'Review Ideas', icon: 'Assessment' },
    { path: '/engagements', label: 'My Engagements', icon: 'Assignment' },
    { path: '/calendar', label: 'Calendar', icon: 'CalendarToday' },
    { path: '/tasks', label: 'Tasks', icon: 'Checklist' },
    { path: '/donor-donations', label: 'Donation', icon: 'Assessment' },
  ],
};

// Get routes for a specific role (ecosystem_partner and corporate_sponsor share same nav)
export const getRoutesForRole = (role) => {
  if (role === "corporate_sponsor") {
    return roleRoutes.ecosystem_partner;
  }
  return roleRoutes[role] || roleRoutes.student; // Default to student routes if role not found
};

// Check if a role has access to a specific path
export const hasAccessToRoute = (role, path) => {
  const routes = getRoutesForRole(role);
  return routes.some((route) => route.path === path);
};

// Get all accessible paths for a role
export const getAccessiblePaths = (role) => {
  const routes = getRoutesForRole(role);
  return routes.map((route) => route.path);
};
